(() => {
  if (customElements.get('obm-navigation')) return;
  class ObmNavigation extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.menu = this.querySelector('.obm-main-menu');
      this.toggle = this.querySelector('.obm-menu-toggle');
      this.backdrop = this.querySelector('.obm-menu-backdrop');
      this.search = this.querySelector('#ObmSearchInput');
      this.results = this.querySelector('#ObmSearchResults');
      this.form = this.querySelector('.obm-search-form');
      this.status = this.querySelector('[data-search-status]');
      this.toggle.addEventListener('click', () => this.openMenu());
      this.querySelector('.obm-menu-close').addEventListener('click', () => this.closeMenu());
      this.backdrop.addEventListener('click', () => this.closeMenu());
      this.media = matchMedia('(max-width: 760px)');
      this.onResize = () => {
        if (!this.media.matches) this.closeMenu(false);
        this.querySelectorAll('.obm-menu-family').forEach(el => {
          el.open = !this.media.matches;
          el.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
        });
      };
      this.onResize();
      this.media.addEventListener('change', this.onResize);
      this.querySelectorAll('.obm-top-disclosure').forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (detail.open) {
            this.closeSearch();
            this.querySelectorAll('.obm-top-disclosure').forEach(other => { if (other !== detail) other.open = false; });
          }
        });
      });
      this.search.addEventListener('input', () => {
        clearTimeout(this.timer);
        const term = this.search.value.trim();
        if (this.controller) this.controller.abort();
        if (term.length < 2) { this.closeSearch(); return; }
        this.timer = setTimeout(() => this.searchFor(term), 220);
      });
      this.search.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && !this.results.hidden) {
          event.preventDefault(); this.results.querySelector('a,button')?.focus();
        }
        if (event.key === 'Escape') this.closeSearch();
      });
      this.results.addEventListener('keydown', event => {
        const links = [...this.results.querySelectorAll('a,button')];
        const index = links.indexOf(document.activeElement);
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const next = index + (event.key === 'ArrowDown' ? 1 : -1);
          if (next < 0) this.search.focus(); else links[Math.min(next, links.length - 1)]?.focus();
        }
        if (event.key === 'Escape') { this.closeSearch(); this.search.focus(); }
      });
      this.results.addEventListener('click', event => {
        if (event.target.closest('.obm-view-search')) this.form.requestSubmit();
      });
      this.documentClick = event => {
        if (!this.contains(event.target)) {
          this.closeSearch();
          this.querySelectorAll('.obm-top-disclosure').forEach(el => { el.open = false; });
        }
      };
      this.documentKey = event => {
        if (event.key === 'Escape') {
          if (this.classList.contains('is-menu-open')) this.closeMenu();
          this.closeSearch();
          this.querySelectorAll('.obm-top-disclosure[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
        }
        if (event.key === 'Tab' && this.classList.contains('is-menu-open')) {
          const focusable = [...this.menu.querySelectorAll('button,a,summary')].filter(el => el.getClientRects().length);
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      };
      document.addEventListener('click', this.documentClick);
      document.addEventListener('keydown', this.documentKey);
    }
    openMenu() {
      this.closeSearch(); this.classList.add('is-menu-open');
      this.backdrop.hidden = false; this.toggle.setAttribute('aria-expanded', 'true');
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.menu.setAttribute('role', 'dialog'); this.menu.setAttribute('aria-modal', 'true');
      this.querySelector('.obm-menu-close').focus();
    }
    closeMenu(restoreFocus = true) {
      const wasOpen = this.classList.contains('is-menu-open');
      this.classList.remove('is-menu-open'); this.backdrop.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.menu.removeAttribute('role'); this.menu.removeAttribute('aria-modal');
      if (wasOpen) { document.body.style.overflow = this.previousOverflow || ''; if (restoreFocus) this.toggle.focus(); }
    }
    closeSearch() { this.results.hidden = true; this.search.setAttribute('aria-expanded', 'false'); }
    async searchFor(term) {
      this.controller = new AbortController();
      const params = new URLSearchParams({q: term, 'resources[type]': 'product,collection', 'resources[limit]': '6', section_id: 'obm-predictive-search'});
      try {
        const response = await fetch(`${this.dataset.predictiveUrl}?${params}`, {signal: this.controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-obm-predictive-content]');
        if (!content || this.search.value.trim() !== term) return;
        this.results.replaceChildren(content);
        this.results.hidden = false; this.search.setAttribute('aria-expanded', 'true');
        this.querySelectorAll('.obm-top-disclosure').forEach(el => { el.open = false; });
        this.status.textContent = `${this.results.querySelectorAll('li[role="option"]').length} suggestions available.`;
      } catch (error) {
        if (error.name !== 'AbortError') { this.closeSearch(); this.status.textContent = 'Press Search to see your results.'; }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer); this.controller?.abort();
      this.media?.removeEventListener('change', this.onResize);
      document.removeEventListener('click', this.documentClick);
      document.removeEventListener('keydown', this.documentKey);
      if (this.classList.contains('is-menu-open')) document.body.style.overflow = this.previousOverflow || '';
      this.bound = false;
    }
  }
  customElements.define('obm-navigation', ObmNavigation);
  document.addEventListener('change', event => {
    if (event.target.matches('.obm-sort select')) event.target.form.requestSubmit();
  });
})();
